module.exports = __webpack_public_path__ + "static/media/MSSlong.3bdf86e2.png";